var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hideManage
        ? [
            _c(
              "div",
              { staticClass: "flex flex_gap_5" },
              [
                _vm._l(_vm.list, function (d, i) {
                  return i < 5
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.onSelect(d)
                            },
                          },
                        },
                        [_vm._v("\n        " + _vm._s(d) + "\n      ")]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.openEditBlock },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                ),
              ],
              2
            ),
          ]
        : [
            _c("div", [
              _c("div", { staticClass: "mb-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newSnippet,
                      expression: "newSnippet",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Новый ответ для чатов" },
                  domProps: { value: _vm.newSnippet },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.newSnippet = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right mt-1" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Сохранить",
                        type: "button",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.LOADING_COLOR,
                        onClick: () => _vm.saveSnippet(),
                        className: "btn btn-outline-info",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "draggable",
                    {
                      attrs: { tag: "div" },
                      on: {
                        update: function ($event) {
                          return _vm.updateOrderList()
                        },
                      },
                      model: {
                        value: _vm.list,
                        callback: function ($$v) {
                          _vm.list = $$v
                        },
                        expression: "list",
                      },
                    },
                    [
                      _c(
                        "transition-group",
                        { attrs: { type: "transition", name: "flip-list" } },
                        _vm._l(_vm.list, function (d, i) {
                          return _c(
                            "div",
                            {
                              key: `btn_${i}`,
                              staticClass: "btn-group mb-1 w-100",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default w-100 text-left",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSelect(d)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(d))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveSnippet(true, i)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-trash-o",
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }